import React, { useEffect, useState, useRef, useMemo } from "react";
import { SortByHeader } from "pages/Fleet/Cars/SortByHeader";
import { SearchHeader } from "pages/Fleet/Cars/SearchHeader";
import { ListView } from "pages/Fleet/Cars/ListView";
import { Container } from "pages/Fleet/Cars/CarStyled";
import { FleetFindCar } from "pages/Fleet/Cars/CarStyled";
import { useHookstate } from "@hookstate/core";
import { MESSAGE_FLEET_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "../../../globalStore/globalStore";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { LIST_BY_GLOBAL_STATES } from "globalStore/globalStore";

import { COMMON_COMPONENTS_STATES } from "../../../globalStore/globalStore";
import { TagCarsComponent } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";
import { ActionWrapper } from "../../../pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import { TagCarsComponent1 } from "../../../commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";
import { getAllDevicesBySite } from "../../../redux/reduxToolkitServices/_commonServices/centralServices";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const Cars = () => {
  const { siteId, centralDeviceInfo } = useHookstate(SITEID_GLOBAL_STATE);

  const [height, setHeight] = useState(0);
  const [filterHeight, setFilterHeight] = useState(0);
  const [searchHeaderHeight, setSearchHeaderHeight] = useState(0);

  const filterDataRef = useRef(null);
  const filterH = useRef(null);
  const searchH = useRef(null);

  const [carListCount, setCarListCount] = useState(0);
  const [carListCountInvert, setCarListCountInvert] = useState(0);
  const [getFleetcarsInput, setGetFleetcarsInput] = useState("");
  const [getFleetcarsInputInvert, setGetFleetcarsInputInvert] = useState("");
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [disableselectAll, setDisableSelectAll] = useState(false);
  const [disableselectAllInvert, setDisableSelectAllInvert] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllInvert, setSelectAllInvert] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageInvert, setCurrentPageInvert] = useState(1);
  const [hideVehicleInfoColumns, setHideVehicleInfoColumns] = useState(false);
  const [toggleAppInfo, setToggleAppInfo] = useState(true);
  const [toggleSimInfo, setToggleSimInfo] = useState(true);
  const [toggleFTSWInfo, setToggleFTSWInfo] = useState(true);

  useEffect(() => {
    const fetchCentralInfo = async () => {
      const centralInfo = await getAllDevicesBySite(siteId.get());
      centralDeviceInfo.set(centralInfo);
    };

    fetchCentralInfo();
  }, [siteId.get()]);

  useEffect(() => {
    setCurrentPage(1);
    setCurrentPageInvert(1);
  }, [getFleetcarsInput, getFleetcarsInputInvert, rowsPerPage]);

  useEffect(() => {
    if (rowsPerPage === "All") return;
    const totalPages = Math.ceil(carListCount / rowsPerPage);
    if (currentPage > totalPages) {
      setCurrentPage(totalPages || 1);
    }
  }, [carListCount, rowsPerPage]);

  useEffect(() => {
    if (rowsPerPage === "All") return;
    const totalPagesInvert = Math.ceil(carListCountInvert / rowsPerPage);
    if (currentPageInvert > totalPagesInvert) {
      setCurrentPageInvert(totalPagesInvert || 1);
    }
  }, [carListCountInvert, rowsPerPage]);

  const dispatch = useDispatch();
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const { showTagCarsState, showTagCarsStatenew, showTagCarState2 } =
    useHookstate(COMMON_COMPONENTS_STATES);

  const { listBy } = useHookstate(LIST_BY_GLOBAL_STATES);

  const { getCarsData, siteSettingDataReduxStateStatus } = useSelector((state) => state?.commonReducers) || [];

  const TopSection = `${windowDimensions.width <= 850
    ? filterHeight + searchHeaderHeight + 58 + 70
    : filterHeight + searchHeaderHeight + 58
    }`;

  const totalHeight = `${windowDimensions.width <= 850
    ? height + filterHeight + searchHeaderHeight + filterHeight + 58 + 70
    : height + filterHeight + searchHeaderHeight + filterHeight + 58
    }`;

  const listMaxHeight = useMemo(() => {
    return listBy.get() !== "NONE"
      ? "230px"
      : `calc(100vh - ${TopSection}px)`;
  }, [listBy.get(), TopSection]);

  const listMaxHeightTotalWeight = useMemo(() => {
    return windowDimensions.width <= 850 && window.innerHeight <= window.innerWidth
      ? "400px"
      : `calc(100vh - ${totalHeight}px)`
  }, [listBy.get(), totalHeight]);

  useEffect(() => {
    let timeout;
    function handleResize() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setWindowDimensions(getWindowDimensions());
      }, 150);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (filterDataRef.current?.clientHeight === null) {
      return;
    } else {
      setHeight(filterDataRef.current?.clientHeight);
    }
  }, []);

  //-------filter height ---------------
  useEffect(() => {
    if (filterH.current?.clientHeight === null) {
      return;
    } else {
      setFilterHeight(filterH.current?.clientHeight);
    }
  }, []);

  //-------Search Header height ---------------
  useEffect(() => {
    if (searchH.current?.clientHeight === null) {
      return;
    } else {
      setSearchHeaderHeight(searchH.current?.clientHeight);
    }
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
  }, [siteId.get()]);

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST || getCarsData === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  return (
    <>
      <Container style={{ backgroundColor: isLoading.get() ? "#f7f7f7" : "" }}>
        <div ref={filterH}>
          <SortByHeader />
        </div>
        <div ref={searchH}>
          <SearchHeader
            invert={false}
            count={carListCount}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            disableselectAll={disableselectAll}
            disableselectAllInvert={disableselectAllInvert}
            getFleetcarsInput={getFleetcarsInput}
            setGetFleetcarsInput={setGetFleetcarsInput}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            hideVehicleInfoColumns={hideVehicleInfoColumns}
            setHideVehicleInfoColumns={setHideVehicleInfoColumns}
            toggleAppInfo={toggleAppInfo}
            setToggleAppInfo={setToggleAppInfo}
            toggleSimInfo={toggleSimInfo}
            setToggleSimInfo={setToggleSimInfo}
            toggleFTSWInfo={toggleFTSWInfo}
            setToggleFTSWInfo={setToggleFTSWInfo}
          />
        </div>
        {showTagCarsState.get() || showTagCarState2.get() ? <TagCarsComponent /> : <></>}
        {showTagCarsStatenew.get() ? <TagCarsComponent1 /> : <></>}

        <div ref={filterDataRef}>
          <ListView
            invert={false}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            setDisableSelectAll={setDisableSelectAll}
            setDisableSelectAllInvert={setDisableSelectAllInvert}
            setCarListCount={setCarListCount}
            maxHeight={listMaxHeight}
            getFleetcarsInput={getFleetcarsInput}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            hideVehicleInfoColumns={hideVehicleInfoColumns}
            toggleAppInfo={toggleAppInfo}
            toggleSimInfo={toggleSimInfo}
            toggleFTSWInfo={toggleFTSWInfo}
          />
        </div>
        {listBy.get() !== "NONE" && (
          <>
            <SearchHeader
              invert={true}
              count={carListCountInvert}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              disableselectAll={disableselectAll}
              disableselectAllInvert={disableselectAllInvert}
              className="new-search-header"
              getFleetcarsInput={getFleetcarsInputInvert}
              setGetFleetcarsInput={setGetFleetcarsInputInvert}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPageInvert}
              setCurrentPage={setCurrentPageInvert}
              hideVehicleInfoColumns={hideVehicleInfoColumns}
              setHideVehicleInfoColumns={setHideVehicleInfoColumns}
              toggleAppInfo={toggleAppInfo}
              setToggleAppInfo={setToggleAppInfo}
              toggleSimInfo={toggleSimInfo}
              setToggleSimInfo={setToggleSimInfo}
              toggleFTSWInfo={toggleFTSWInfo}
              setToggleFTSWInfo={setToggleFTSWInfo}
            />
            {showTagCarsState.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            {showTagCarState2.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}
            {showTagCarsStatenew.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent1 />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            <ListView
              invert={true}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              setDisableSelectAll={setDisableSelectAll}
              setDisableSelectAllInvert={setDisableSelectAllInvert}
              setCarListCountInvert={setCarListCountInvert}
              maxHeight={listMaxHeightTotalWeight}
              getFleetcarsInput={getFleetcarsInputInvert}
              rowsPerPage={rowsPerPage}
              currentPage={currentPageInvert}
              hideVehicleInfoColumns={hideVehicleInfoColumns}
              toggleAppInfo={toggleAppInfo}
              toggleSimInfo={toggleSimInfo}
              toggleFTSWInfo={toggleFTSWInfo}
            />
          </>
        )}
      </Container>
    </>
  );
};